import { observer } from 'mobx-react';
import { BorrowerPortalCard, getGridCardStyles } from '@roc/feature-borrower-portal-core';
import { useEffect } from 'react';
import { Box } from '@material-ui/core';
import { BorrowerReferralsDataGrid } from './borrowerReferralsDataGrid';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Layout } from '@roc/feature-app-core';

export const BorrowerReferrals = observer(() => {
  const classes = getGridCardStyles();
  const { userStore, referralWiringInformationStore } = useStore();

  useEffect(() => {
    referralWiringInformationStore.getReferralWiringInformation(userStore.userInformation.userId);
  }, []);

  return (
    <Layout title="Borrower Referrals">
      <Box className={classes.cardContent}>
        <BorrowerPortalCard cardContentClassName={classes.cardContent}>
          <BorrowerReferralsDataGrid />
        </BorrowerPortalCard>
      </Box>
    </Layout>
  );
});
